import { connect, MapDispatchToProps } from 'react-redux';
import { Props } from './DeviationPaywall';
import { showPremiumFolderPopup } from '@wix/da-shared-react/pkg/Modals/redux/actionCreators';

type DispatchProps = Pick<Props, 'showPremiumFolderPopup'>;
export type OwnProps = Omit<Props, keyof DispatchProps>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  showPremiumFolderPopup,
};

export default connect(null, mapDispatchToProps);
